import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";
import { BrandMark } from "./BrandMark";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/5 bg-ink-900/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="space-y-4">
          <BrandMark size={44} showWord />
          <p className="text-sm text-white/60 leading-relaxed max-w-xs">
            Luxury chauffeur service and self-drive rentals across New York, New Jersey, Pennsylvania, the DMV and Connecticut. Discretion. Power. Time.
          </p>
        </div>
        <div>
          <div className="label-caps text-gold mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/fleet?mode=chauffeur">Chauffeur Fleet</Link></li>
            <li><Link to="/fleet?mode=rental">Rental Fleet</Link></li>
            <li><Link to="/bookings">My Bookings</Link></li>
            <li><Link to="/support">Contact</Link></li>
            <li><Link to="/faq" data-testid="footer-faq-link">FAQ</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-caps text-gold mb-3">Service</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Airport transfers (JFK · LGA · EWR)</li>
            <li>Executive roadshows</li>
            <li>Weddings & events</li>
            <li>Multi-day rentals</li>
          </ul>
        </div>
        <div>
          <div className="label-caps text-gold mb-3">Reach us</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin size={14} className="text-gold flex-shrink-0 mt-0.5" /> <span>1818 East New York Ave<br />Brooklyn, NY 11207</span></li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-gold" /> +1 (929) 899-3467</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-gold" /> concierge@plentyrydez.com</li>
            <li className="flex items-center gap-4 pt-2">
              <a href="#" className="hover:text-gold" aria-label="Instagram"><Instagram size={18} /></a>
              <a href="#" className="hover:text-gold" aria-label="Twitter"><Twitter size={18} /></a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Plenty Rydez · A luxury ground service · Licensed in NY · NJ · PA · DMV · CT
        <span className="mx-2 text-white/20">·</span>
        <Link
          to="/manager-login"
          data-testid="footer-staff-link"
          className="text-white/60 hover:text-electric transition-colors"
        >
          Staff / Manager sign-in
        </Link>
      </div>
    </footer>
  );
}
